/* Storybook of Us — storybook characters.
   ElrAvatar.couple(a, b) returns an SVG of two characters holding hands.
   Each character is built from options so customers can make them look like
   themselves; the same SVG is used in the live preview and the print files. */
(function (root) {
  var SKIN = { porcelain: '#f7dcc9', light: '#efc4a4', medium: '#d9a27d', tan: '#bc7f59', brown: '#8f5c3d', deep: '#5f3b28' };
  var HAIR_COLOR = { black: '#2b2325', darkbrown: '#4b3227', brown: '#7b4f2e', auburn: '#a4492c', blonde: '#dfb766', grey: '#bdb6ae' };
  var HAIR = ['short', 'buzz', 'curly', 'long', 'wavy', 'bun', 'bob', 'afro', 'ponytail'];
  var OUTFIT = { rose: '#c9687f', sage: '#86a58c', navy: '#3f4c6e', mustard: '#d6a547', cream: '#eee3d0', lilac: '#a693c3' };
  var LINE = '#4a3436';
  var DEFAULTS = {
    to: { skin: 'light', hair: 'long', hairColor: 'brown', outfit: 'rose', style: 'dress', beard: 'none', glasses: false },
    from: { skin: 'medium', hair: 'short', hairColor: 'darkbrown', outfit: 'navy', style: 'shirt', beard: 'none', glasses: false }
  };
  var LABELS = {
    skin: { porcelain: 'Porcelain', light: 'Light', medium: 'Medium', tan: 'Tan', brown: 'Brown', deep: 'Deep' },
    hair: { short: 'Short', buzz: 'Buzz / bald', curly: 'Curly short', long: 'Long', wavy: 'Wavy', bun: 'Bun', bob: 'Bob', afro: 'Afro', ponytail: 'Ponytail' },
    hairColor: { black: 'Black', darkbrown: 'Dark brown', brown: 'Brown', auburn: 'Auburn', blonde: 'Blonde', grey: 'Grey' },
    outfit: { rose: 'Rose', sage: 'Sage', navy: 'Navy', mustard: 'Mustard', cream: 'Cream', lilac: 'Lilac' },
    style: { dress: 'Dress', shirt: 'Shirt & trousers' },
    beard: { none: 'None', stubble: 'Stubble', beard: 'Beard', moustache: 'Moustache' }
  };

  function pick(map, key, fallback) { return map[key] || map[fallback]; }
  function norm(o, who) {
    var d = DEFAULTS[who] || DEFAULTS.to, p = {};
    Object.keys(d).forEach(function (k) { p[k] = o && o[k] != null ? o[k] : d[k]; });
    if (HAIR.indexOf(p.hair) < 0) p.hair = d.hair;
    return p;
  }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var f = function (c) { return Math.max(0, Math.min(255, Math.round(c + (amt < 0 ? c : 255 - c) * amt))); };
    return '#' + ((1 << 24) + (f(r) << 16) + (f(g) << 8) + f(b)).toString(16).slice(1);
  }

  // Hair drawn behind the head (long styles) and in front (fringe/top).
  function hairBack(style, c) {
    var s = 'fill="' + c + '" stroke="' + LINE + '" stroke-width="1.6" stroke-linejoin="round"';
    switch (style) {
      case 'long': return '<path ' + s + ' d="M28 60 C26 30 94 30 92 60 L96 128 C84 136 36 136 24 128 Z"/>';
      case 'wavy': return '<path ' + s + ' d="M28 60 C26 30 94 30 92 60 C98 76 90 86 97 100 C103 114 92 124 96 132 C80 140 40 140 24 132 C28 124 17 114 23 100 C30 86 22 76 28 60 Z"/>';
      case 'bob': return '<path ' + s + ' d="M27 62 C25 30 95 30 93 62 L95 94 C82 100 38 100 25 94 Z"/>';
      case 'afro': return '<path ' + s + ' d="M60 14 C86 12 104 30 102 54 C108 72 98 92 84 90 L36 90 C22 92 12 72 18 54 C16 30 34 12 60 14 Z"/>';
      case 'ponytail': return '<path ' + s + ' d="M86 44 C104 50 106 84 96 108 C92 96 90 80 84 66 Z"/>';
      case 'bun': return '<circle ' + s + ' cx="60" cy="24" r="13"/>';
      default: return '';
    }
  }
  function hairFront(style, c) {
    var s = 'fill="' + c + '" stroke="' + LINE + '" stroke-width="1.6" stroke-linejoin="round"';
    switch (style) {
      case 'buzz': return '<path fill="' + c + '" opacity=".55" d="M31 56 C32 34 88 34 89 56 C80 44 40 44 31 56 Z"/>';
      case 'short': return '<path ' + s + ' d="M30 60 C26 34 52 26 66 30 C82 32 94 42 90 60 C84 50 76 46 68 45 C58 50 42 52 30 60 Z"/>';
      case 'curly': return '<path ' + s + ' d="M29 60 C22 50 28 36 38 36 C40 26 52 24 58 30 C64 22 78 24 80 34 C92 34 98 48 91 60 C86 54 82 52 78 54 C74 48 68 50 64 52 C58 46 50 50 46 52 C40 48 34 52 29 60 Z"/>';
      case 'afro': return '<path ' + s + ' d="M30 62 C26 44 40 34 60 34 C80 34 94 44 90 62 C84 52 72 48 60 48 C48 48 36 52 30 62 Z"/>';
      case 'long': case 'wavy': case 'ponytail': case 'bun':
        return '<path ' + s + ' d="M29 64 C26 36 50 28 62 30 C80 30 96 40 91 64 C84 50 70 44 60 44 C56 52 42 58 29 64 Z"/>';
      case 'bob': return '<path ' + s + ' d="M28 66 C24 36 50 28 62 30 C82 30 96 40 92 66 C88 56 82 48 74 46 C62 46 44 50 28 66 Z"/>';
      default: return '';
    }
  }
  function face(p) {
    var skin = pick(SKIN, p.skin, 'light');
    var out = '';
    // eyes, cheeks, smile
    out += '<circle cx="49" cy="66" r="2.6" fill="' + LINE + '"/><circle cx="71" cy="66" r="2.6" fill="' + LINE + '"/>';
    out += '<circle cx="50" cy="65" r=".8" fill="#fff"/><circle cx="72" cy="65" r=".8" fill="#fff"/>';
    out += '<ellipse cx="43" cy="75" rx="5" ry="3" fill="#e8838f" opacity=".45"/><ellipse cx="77" cy="75" rx="5" ry="3" fill="#e8838f" opacity=".45"/>';
    out += '<path d="M53 77 Q60 83 67 77" fill="none" stroke="' + LINE + '" stroke-width="1.8" stroke-linecap="round"/>';
    var hc = pick(HAIR_COLOR, p.hairColor, 'brown');
    if (p.beard === 'beard') out += '<path fill="' + hc + '" stroke="' + LINE + '" stroke-width="1.4" d="M34 72 C36 96 50 102 60 102 C70 102 84 96 86 72 C80 84 72 86 60 86 C48 86 40 84 34 72 Z M52 80 Q60 76 68 80 Q60 84 52 80 Z"/>';
    if (p.beard === 'moustache') out += '<path fill="' + hc + '" stroke="' + LINE + '" stroke-width="1.2" d="M50 76 C54 72 58 73 60 75 C62 73 66 72 70 76 C66 78 62 77 60 76 C58 77 54 78 50 76 Z"/>';
    if (p.beard === 'stubble') out += '<path fill="' + hc + '" opacity=".28" d="M36 74 C40 94 52 100 60 100 C68 100 80 94 84 74 C78 86 70 88 60 88 C50 88 42 86 36 74 Z"/>';
    if (p.glasses === true || p.glasses === 'true') out += '<g fill="rgba(255,255,255,.25)" stroke="' + LINE + '" stroke-width="1.6"><circle cx="49" cy="66" r="7.5"/><circle cx="71" cy="66" r="7.5"/><path d="M56.5 66 H63.5" fill="none"/></g>';
    return out;
  }

  // Arm shapes: shoulder -> hand. Left shoulder (40,108), right shoulder (80,108).
  var ARMS = {
    L: { down: ['M40 108 C32 128 30 146 32 162', [32, 164]], reach: ['M40 108 C26 126 16 140 4 146', [4, 146]],
         up: ['M40 108 C30 92 24 74 20 56', [20, 54]], wave: ['M40 108 C24 100 16 84 14 66', [14, 64]],
         hug: ['M42 108 C36 103 31 100 24 103', [24, 103]] },
    R: { down: ['M80 108 C88 128 90 146 88 162', [88, 164]], reach: ['M80 108 C94 126 104 140 116 146', [116, 146]],
         up: ['M80 108 C90 92 96 74 100 56', [100, 54]], wave: ['M80 108 C96 100 104 84 106 66', [106, 64]],
         hug: ['M78 108 C84 103 89 100 96 103', [96, 103]] }
  };
  function sleeve(side, kind, oc) {
    var a = ARMS[side][kind] || ARMS[side].down;
    return '<path d="' + a[0] + '" fill="none" stroke="' + LINE + '" stroke-width="12.5" stroke-linecap="round"/><path d="' + a[0] + '" fill="none" stroke="' + oc + '" stroke-width="9.5" stroke-linecap="round"/>';
  }
  function hand(side, kind, skin, st) {
    var a = ARMS[side][kind] || ARMS[side].down;
    return '<circle cx="' + a[1][0] + '" cy="' + a[1][1] + '" r="6" fill="' + skin + '"' + st + '/>';
  }
  function arm(side, kind, skin, oc, st) { return sleeve(side, kind, oc) + hand(side, kind, skin, st); }

  // One character, standing, 120 x 260.
  // arms: 'left' | 'right' | '' (legacy: reach that arm to hold hands) or {l, r, tilt}
  //   l / r: down | reach | up | wave | hug. 'hug' arms are drawn in front (returned as .front).
  function figure(o, who, arms) {
    if (typeof arms !== 'object' || !arms) arms = { l: arms === 'left' ? 'reach' : 'down', r: arms === 'right' ? 'reach' : 'down' };
    var p = norm(o, who);
    var skin = pick(SKIN, p.skin, 'light'), hc = pick(HAIR_COLOR, p.hairColor, 'brown'), oc = pick(OUTFIT, p.outfit, 'rose');
    var st = ' stroke="' + LINE + '" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"';
    var g = '', front = '';
    var tilt = arms.tilt || 0, head = tilt ? '<g transform="rotate(' + tilt + ' 60 96)">' : '<g>';
    g += head + hairBack(p.hair, hc) + '</g>';
    // legs + shoes
    var legTop = p.style === 'dress' ? 196 : 168;
    var legFill = p.style === 'dress' ? skin : shade(oc === OUTFIT.cream ? '#6b6f86' : '#46506b', 0);
    if (p.style === 'shirt') {
      g += '<path fill="' + legFill + '"' + st + ' d="M42 166 L40 236 L57 236 L60 186 L63 236 L80 236 L78 166 Z"/>';
    } else {
      g += '<rect x="47" y="' + legTop + '" width="9" height="40" rx="4" fill="' + skin + '"' + st + '/><rect x="64" y="' + legTop + '" width="9" height="40" rx="4" fill="' + skin + '"' + st + '/>';
    }
    g += '<path fill="#5a4146"' + st + ' d="M38 234 C38 228 58 228 58 234 L58 240 L36 240 Z"/><path fill="#5a4146"' + st + ' d="M62 234 C62 228 82 228 82 234 L84 240 L62 240 Z"/>';
    // Arms sit behind the body. A hugging arm reaches over to rest on the partner's near
    // shoulder, so it is returned as .front and drawn on top of them.
    if (arms.l === 'hug') front += arm('L', 'hug', skin, oc, st); else g += arm('L', arms.l, skin, oc, st);
    if (arms.r === 'hug') front += arm('R', 'hug', skin, oc, st); else g += arm('R', arms.r, skin, oc, st);
    // body
    if (p.style === 'dress') g += '<path fill="' + oc + '"' + st + ' d="M44 100 C50 96 70 96 76 100 L82 150 L96 200 C74 208 46 208 24 200 L38 150 Z"/><path d="M40 150 C52 154 68 154 80 150" fill="none" stroke="' + shade(oc, -0.18) + '" stroke-width="2"/>';
    else g += '<path fill="' + oc + '"' + st + ' d="M40 102 C48 96 72 96 80 102 L84 170 L36 170 Z"/><path d="M52 98 L60 110 L68 98" fill="' + shade(oc, 0.35) + '"' + st + '/>';
    // neck + head
    g += '<rect x="53" y="88" width="14" height="14" rx="5" fill="' + skin + '"' + st + '/>';
    g += head;
    g += '<ellipse cx="29" cy="68" rx="5" ry="7" fill="' + skin + '"' + st + '/><ellipse cx="91" cy="68" rx="5" ry="7" fill="' + skin + '"' + st + '/>';
    g += '<ellipse cx="60" cy="64" rx="31" ry="32" fill="' + skin + '"' + st + '/>';
    g += face(p);
    g += hairFront(p.hair, hc) + '</g>';
    return { body: g, front: front };
  }
  function person(o, who, reach) { var f = figure(o, who, reach); return f.body + f.front; }

  var HEART = '<path transform="translate(118 8) scale(1.1)" fill="#d4677f" stroke="' + LINE + '" stroke-width="1.3" d="M11 20 C4 15 0 11 0 6.5 C0 3 2.7 0 6 0 C8.2 0 10 1.3 11 3 C12 1.3 13.8 0 16 0 C19.3 0 22 3 22 6.5 C22 11 18 15 11 20 Z"/>';
  // Poses for two characters. from = left, to = right. [fromArms, toArms, fromX, toX]
  var POSES = {
    hands: [{ l: 'down', r: 'reach' }, { l: 'reach', r: 'down' }, 14, 126],
    hug: [{ l: 'down', r: 'hug', tilt: 7 }, { l: 'down', r: 'down', tilt: -7 }, 44, 98],
    wave: [{ l: 'wave', r: 'reach' }, { l: 'reach', r: 'wave' }, 14, 126],
    cheer: [{ l: 'up', r: 'up' }, { l: 'up', r: 'up' }, 8, 132],
    side: [{ l: 'down', r: 'down' }, { l: 'down', r: 'wave' }, 16, 124]
  };
  // Two characters with a small heart above. 260 x 272 viewBox. opts: {heart:false, pose:'hands'}
  function couple(a, b, opts) {
    opts = opts || {};
    var ps = POSES[opts.pose] || POSES.hands;
    var from = figure(b, 'from', ps[0]), to = figure(a, 'to', ps[1]);
    return '<svg class="elr-av" viewBox="0 0 260 272" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<ellipse cx="130" cy="262" rx="112" ry="8" fill="#3a2a33" opacity=".12"/>' + (opts.heart === false ? '' : HEART) +
      '<g transform="translate(' + ps[2] + ' 22)">' + from.body + '</g>' +
      '<g transform="translate(' + ps[3] + ' 22)">' + to.body + to.front + '</g>' +
      '<g transform="translate(' + ps[2] + ' 22)">' + from.front + '</g></svg>';
  }
  function single(a, who) {
    return '<svg class="elr-av" viewBox="0 0 120 262" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + person(a, who, '') + '</svg>';
  }

  root.ElrAvatar = { SKIN: SKIN, HAIR: HAIR, HAIR_COLOR: HAIR_COLOR, OUTFIT: OUTFIT, LABELS: LABELS, DEFAULTS: DEFAULTS, couple: couple, single: single, norm: norm, POSES: POSES };
})(typeof window !== 'undefined' ? window : this);
